import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Back",
	updateManyExternalIntegrations: {
		success: "Integrations updated successfully",
	},
	externalStoreIntegrationStatus: {
		synced: "Synced",
		pendingSyncing: "Syncing pending",
		pendingImporting: "Importing pending",
	},
	ordersManager: {
		title: "Orders Manager",
		description:
			"Track and manage orders that come from Entregue já, Comanda Online and Pedido na mesa.",
		filter: {
			placeholder: "Filter by",
		},
		tabs: {
			newOrders: "New Orders",
			inDelivery: "In Delivery",
			completed: "Completed",
		},
		createOrder: "Create new order",
		selectMenuModal: {
			title: "Choose the menu to place the order",
			searchPlaceholder: "Search by menu",
			productsCount: "{{value}} products",
			cancel: "Cancel",
			select: "Select menu",
			empty: "No menu found.",
		},
		createOrderScreen: {
			back: "Back",
			searchPlaceholder: "Search by name or order item",
			filterBy: "Filter by",
			allCategories: "All categories",
			all: "All",
			add: "Add",
			added: "Added",
			cartTitle: "Added items",
			emptyTitle: "Nothing here yet",
			emptyDescription: "Items will appear here as they are added",
			subtotal: "Subtotal",
			discount: "Discount",
			total: "Total",
			clear: "Clear items",
			finalize: "Finish order",
			emptyProducts: "No product found.",
			productDetail: {
				title: "Product details",
				observationLabel: "Notes",
				observationPlaceholder: "Type a note for the order here",
				addProduct: "Add product",
				complementsRule: "Choose up to {{value}} options",
				complementsRuleRequired: "Choose from {{min}} to {{max}} options",
			},
			clearModal: {
				title: "Clear items",
				description:
					"Are you sure you want to clear the items? Once confirmed, you will need to add them again to finish.",
				cancel: "Cancel",
				confirm: "Clear items",
			},
		},
		checkout: {
			back: "Back",
			title: "Order payment",
			customerInfo: {
				title: "Customer information",
				name: "Name",
				namePlaceholder: "Enter the customer's first and last name",
				phone: "Phone",
				phonePlaceholder: "Enter the customer's phone number",
				cpf: "CPF",
				cpfPlaceholder: "Enter the customer's CPF number",
				sameWhatsapp: "Same number for WhatsApp",
			},
			delivery: {
				title: "Delivery method",
				pickup: "Pick up at store",
				deliver: "Deliver via mobotoy",
				addressTitle: "Address information",
				cep: "ZIP code",
				cepPlaceholder: "Enter the customer's ZIP code",
				street: "Street",
				streetPlaceholder: "Enter the customer's address",
				number: "Number",
				numberPlaceholder: "Enter the number",
				complement: "Complement",
				complementPlaceholder: "Enter the complement",
			},
			payment: {
				title: "Payment methods",
				pix: "Payment via Pix",
			},
			summary: {
				title: "Order summary",
				deliveryFee: "Delivery fee",
				total: "Total",
				finalize: "Finish order",
			},
		},
		loading: "Loading",
		total: "Total: {{value}}",
		new: "New",
		emptyState: {
			title: "We don't have any {{status}} orders yet.",
			description: "We'll show you here when you receive new orders.",
		},
		immersion: {
			enter: "Immersion",
			exit: "Exit immersion",
		},
		sound: {
			on: "Sound on",
			off: "Sound off",
		},
		whatsNew: {
			intro: {
				title: "We have news here! 🎉",
				description:
					"We've updated the Orders manager. Want a quick look at what changed?",
				start: "See what's new",
			},
			step: "Step {{current}} of {{total}}",
			next: "Next",
			finish: "Got it",
			skip: "Skip",
			test: "Play sample sound",
			immersion: {
				title: "New: Immersion mode",
				description:
					"Put the manager in full screen, without menus — ideal for counter use.",
			},
			sound: {
				title: "New: New order sound",
				description:
					"We play a sound alert when a new order arrives. Use the button to enable or mute it.",
			},
		},
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
